<template>
  <tabs
    v-if="restaurant"
    :tab-name="['Detail', 'Notes']"
    :tab-icon="['event_available', 'text_snippet']"
    class="page-subcategories"
    nav-pills-icons
    color-button="primary"
  >
    <template slot="tab-pane-1">
      <restaurant-edit :restaurant="restaurant" />
    </template>

    <template slot="tab-pane-2">
      <restaurant-tabs-notes :restaurant="restaurant" />
    </template>
  </tabs>
</template>

<script>
import { Tabs } from "@/components";
import restaurantApi from "@/services/api/restaurant";

import RestaurantEdit from "./RestaurantEdit";
import RestaurantTabsNotes from "./RestaurantTabsNotes";

export default {
  props: ["restaurant"],

  components: {
    Tabs,
    RestaurantEdit,
    RestaurantTabsNotes
  },

  data() {
    return {};
  },

  computed: {},

  methods: {}
};
</script>
